export const GAMES_SEARCH_FIELD_NAME = 'games-search'
